// What a clip plays as, in a strip's words: "32 notes", "bounce", or the
// reason it is silent — one reading (shared/playback/geometry.ts
// `clipSounding`) so a strip never says "32 notes" over a clip that plays
// its bounce, or nothing at all.

import { clipSounding, type SoundingClipLike } from "@shared/playback/geometry.js";

export function soundingLabel(clip: SoundingClipLike & { noteCount?: number }): string {
  const s = clipSounding(clip);
  switch (s.kind) {
    case "audio":
      return clip.kind === "midi" ? "bounce" : "audio";
    case "synth": {
      const n = clip.notes?.filter((note) => !note.muted).length ?? clip.noteCount ?? 0;
      return `${n} note${n === 1 ? "" : "s"}`;
    }
    default:
      switch (s.reason) {
        case "notes-omitted":
          return clip.kind === "midi" && (clip.noteCount ?? 0) > 0 ? `silent — ${clip.noteCount} notes, too many to carry` : "silent — no notes";
        case "all-muted":
          return "silent — every note muted";
        case "deactivated":
          return "deactivated";
        default:
          return "silent — no audio";
      }
  }
}
